export enum PermissionAlog {
  /** Výpis auditního logu */
  ALOG_LIST = 'ALOG_LIST',

  /** Detail auditního logu */
  ALOG_DETAIL = 'ALOG_DETAIL',
}
